import script from "./WatchLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./WatchLinks.vue?vue&type=script&setup=true&lang=js"

import "./WatchLinks.vue?vue&type=style&index=0&id=7b88f852&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b88f852"]])

export default __exports__